
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideja/[slug]",
      function () {
        return require("private-next-pages/ideja/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideja/[slug]"])
      });
    }
  